export default "__VITE_PUBLIC_ASSET__39edf0dc__"